/* eslint-disable @typescript-eslint/no-explicit-any */
"use client";

import {
    FormControl,
    FormDescription,
    FormField,
    FormItem,
    FormMessage,
} from "@/shared/components/ui/form";
import { Input } from "@/shared/components/ui/input";
import { BaseFieldProps } from "./form-field-utils";
import { FormFieldLabel } from "./form-field-label";

export function FieldText({
    name,
    label,
    description,
    className,
    labelType = "text",
    tooltipContent,
    ...rest
}: BaseFieldProps & React.ComponentProps<typeof Input>) {
    return (
        <FormField
            name={name}
            render={({ field }) => (
                <FormItem className={className}>
                    <FormFieldLabel label={label} labelType={labelType} tooltipContent={tooltipContent} />
                    <FormControl>
                        <Input {...field} {...rest} />
                    </FormControl>
                    {description && <FormDescription>{description}</FormDescription>}
                    <FormMessage />
                </FormItem>
            )}
        />
    );
}
